module.exports = __webpack_public_path__ + "img/img_body_biz_cs_sharing_logo.ef0f2d62.png";